export interface INucleoFamiliar {
  id: number;
  identificacion: string;
  tipoIdentificacion: string;
  tipoIdentificacionDescripcion?: string;
  nombreCompleto: string;
  primerNombre: string;
  segundoNombre: string;
  primerApellido: string;
  segundoApellido: string;
  fechaNacimiento: string;
  fechaExpedicion: string;
  lugarExpedicion: string;
  genero: string;
  generoDescripcion?: string;
  vinculo: string;
  vinculoDescripcion?: string;
  jefeHogar?: number;
  correo: string;
  barrio: string;
  direccion: string;
  telefonoMovil: string;
  telefonoFijo?: string;
}

export enum TipoSolicitudSisben {
  AGREGAR_MIEMBRO,
  ELIMINAR_MIEMBRO,
  MODIFICAR_DOCUMENTO,
}


export interface IPuntajeSisben {
  id: number;
  puntajeSisben: string;
}
